import React from 'react'
import { CancelIcon, SearchesCIcon } from '../../Static/icons/iconshere';
// import sicon from '../../../assets/img/sicon.png';

const FilterSearch = ({ placeholder, setSearchQuery, searchQuery }) => {
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    return (
        <>
            <div className='searchfields form-group  position-relative mt-2 mb-1'>
            <span className='searchicon'><SearchesCIcon /></span>
            {/* <span className='searchiconcancel'><SearchesCIcon /></span> */}
            <input
                type="text"
                placeholder={placeholder}
                className='form-control'
                value={searchQuery}
                onChange={handleSearchChange}
            />
            {  searchQuery.length > 0 && 
            <span className='filterSearchCancel searchiconcancel' onClick={()=>setSearchQuery('')} >
                <CancelIcon />
            </span>
            }
            </div>
        </>
    )
}

export default FilterSearch
